<ng-container *ngTemplateOutlet="counterTpl; context: {totalResults: totalResults, pageRange: pageRange}"></ng-container>